export default __webpack_public_path__ + "static/media/envio-white-t.fa531e34.png";